import styled from '@emotion/styled';
import React from 'react';
import { sustainableBgState } from '../../data/estimate/common/modal/atom';
import { useRecoilState } from 'recoil';

const Base = styled.div<{ zIndex?: number }>`
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: ${props => props.zIndex && props.zIndex};
  overflow: hidden;
`;

interface Props {
  children?: React.ReactNode;
  zIndex?: number;
}

/**
 *  검은색 배경 컴포넌트
 * @param {number} zIndex background 의 z-index 값 (default: 1)
 *  */
function Background({ children, zIndex = 1 }: Props): JSX.Element {
  const [sustainableBgSelector, setSustainableBgSelector] =
    useRecoilState<boolean>(sustainableBgState);

  const onClick = (): void => {
    // 지속 가능한 검은색 배경일 때 배경을 클릭하면 배경을 닫아줌
    sustainableBgSelector && setSustainableBgSelector(false);
  };

  const onKeyDown = (e: React.KeyboardEvent): void => {
    const key: string = e.key;
    sustainableBgSelector && key === 'Escape' && setSustainableBgSelector(false); // ESC 누를 시 배경 닫기
  };

  return (
    <Base zIndex={zIndex} onKeyDown={onKeyDown} onClick={onClick}>
      {children}
    </Base>
  );
}

export default Background;
